import { render, staticRenderFns } from "./product-cover-by-province.vue?vue&type=template&id=2e4a8c62&scoped=true"
import script from "./product-cover-by-province.vue?vue&type=script&lang=js"
export * from "./product-cover-by-province.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a8c62",
  null
  
)

export default component.exports